import Header from "@/components/Header";
import { Link } from "react-router-dom";

const sections = [
  {
    title: "1. Responsável pelo Tratamento",
    content: `A L4C Aviation Academy, com sede em Portugal, é a entidade responsável pelo tratamento dos dados pessoais recolhidos através deste website e da aplicação móvel L4C Part 66.\n\nEmail de contacto: info@learning4change.pt`,
  },
  {
    title: "2. Dados Pessoais Recolhidos",
    content: `Recolhemos os seguintes dados pessoais:\n\n• Nome completo\n• Endereço de email\n• Informação de contacto (quando fornecida voluntariamente)\n• Dados de utilização da plataforma (progresso nos módulos, resultados de exames simulados)\n• Dados técnicos (endereço IP, tipo de browser, dispositivo)\n• Cookies e tecnologias similares`,
  },
  {
    title: "3. Finalidade do Tratamento",
    content: `Os dados pessoais são tratados para as seguintes finalidades:\n\n• Gestão de conta e autenticação na plataforma\n• Prestação dos serviços de formação e preparação para exames EASA Part 66\n• Acompanhamento do progresso de estudo\n• Comunicações relacionadas com o serviço (atualizações, datas de exame, notificações)\n• Resposta a pedidos de contacto e suporte\n• Envio de comunicações de marketing (apenas com consentimento prévio)\n• Melhoria contínua dos nossos serviços e conteúdos\n• Cumprimento de obrigações legais`,
  },
  {
    title: "4. Base Legal",
    content: `O tratamento dos dados pessoais é realizado com base em:\n\n• Execução de contrato — para a prestação dos serviços contratados\n• Consentimento — para o envio de comunicações de marketing\n• Interesse legítimo — para a melhoria dos serviços e segurança da plataforma\n• Obrigação legal — quando exigido por lei`,
  },
  {
    title: "5. Partilha de Dados",
    content: `Os dados pessoais podem ser partilhados com:\n\n• Prestadores de serviços tecnológicos (alojamento, email, analytics) que atuam como subcontratantes\n• Entidades parceiras Part 147, apenas quando necessário para a inscrição em exames oficiais e com o consentimento do utilizador\n• Autoridades competentes, quando exigido por lei\n\nNão vendemos nem cedemos dados pessoais a terceiros para fins comerciais.`,
  },
  {
    title: "6. Transferências Internacionais",
    content: `Alguns dos nossos prestadores de serviços podem estar localizados fora do Espaço Económico Europeu (EEE). Nestes casos, asseguramos que existem garantias adequadas de proteção de dados, em conformidade com o RGPD.`,
  },
  {
    title: "7. Período de Conservação",
    content: `Os dados pessoais são conservados pelo período necessário para a finalidade para a qual foram recolhidos:\n\n• Dados de conta: durante a vigência do contrato e até 5 anos após o seu término\n• Dados de marketing: até à retirada do consentimento\n• Dados de utilização: até 2 anos após a última interação\n• Dados legais: pelo período exigido por lei`,
  },
  {
    title: "8. Direitos do Titular",
    content: `Nos termos do RGPD, tens os seguintes direitos:\n\n• Direito de acesso — solicitar informação sobre os dados tratados\n• Direito de retificação — corrigir dados inexatos ou incompletos\n• Direito ao apagamento — solicitar a eliminação dos dados\n• Direito à limitação — restringir o tratamento dos dados\n• Direito à portabilidade — receber os dados num formato estruturado\n• Direito de oposição — opor-se ao tratamento dos dados\n• Direito de retirar o consentimento — a qualquer momento\n\nPara exercer estes direitos, contacta-nos através de info@learning4change.pt`,
  },
  {
    title: "9. Cookies",
    content: `Este website utiliza cookies para:\n\n• Cookies essenciais — necessários para o funcionamento do site\n• Cookies de desempenho — para análise de utilização e melhoria do serviço\n• Cookies de funcionalidade — para guardar as tuas preferências\n\nPodes gerir as preferências de cookies nas definições do teu browser.`,
  },
  {
    title: "10. Segurança",
    content: `Implementamos medidas técnicas e organizativas adequadas para proteger os dados pessoais contra perda, uso indevido, acesso não autorizado, divulgação, alteração ou destruição, incluindo encriptação de dados em trânsito e em repouso.`,
  },
  {
    title: "11. Alterações à Política",
    content: `Esta política de privacidade pode ser atualizada periodicamente. Quaisquer alterações significativas serão comunicadas através do website ou por email. A data da última atualização está indicada no topo desta página.`,
  },
  {
    title: "12. Contacto e Reclamações",
    content: `Para questões relacionadas com a proteção de dados:\n\n• Email: info@learning4change.pt\n• Morada: Portugal\n\nTens também o direito de apresentar reclamação junto da Comissão Nacional de Proteção de Dados (CNPD) — www.cnpd.pt`,
  },
];

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <Header />

      <div className="bg-[#0A1628] py-16 md:py-20 pt-[140px]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#00A8FF] mb-3">LEGAL</p>
          <div className="w-12 h-0.5 bg-gradient-to-r from-[#00A8FF] to-[#F59E0B] mb-6" />
          <h1 className="font-['Outfit'] text-4xl md:text-5xl font-black text-white mb-4">
            Política de Privacidade
          </h1>
          <p className="text-slate-400 text-sm">
            Última atualização: 15 de Abril de 2026
          </p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 py-16">
        <div className="bg-white rounded-lg border border-slate-200 p-8 md:p-12 mb-8">
          <p className="text-base text-slate-600 leading-relaxed mb-8">
            A L4C Aviation Academy compromete-se a proteger a privacidade e os dados pessoais dos seus
            utilizadores, em conformidade com o Regulamento Geral sobre a Proteção de Dados (RGPD) —
            Regulamento (UE) 2016/679 — e a legislação portuguesa aplicável. Esta política descreve como
            recolhemos, utilizamos, armazenamos e protegemos os teus dados pessoais.
          </p>

          {sections.map((section, i) => (
            <div key={i} className="mb-10 last:mb-0" data-testid={`privacy-section-${i}`}>
              <h2 className="font-['Outfit'] text-xl font-bold text-[#0A1628] mb-4 flex items-center gap-3">
                <span className="w-1 h-6 bg-gradient-to-b from-[#00A8FF] to-[#F59E0B] rounded-full" />
                {section.title}
              </h2>
              <div className="text-slate-600 text-[15px] leading-relaxed whitespace-pre-line pl-4">
                {section.content}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center text-sm text-slate-400 py-8">
          <p>&copy; 2026 L4C Aviation Academy. Todos os direitos reservados.</p>
          <Link to="/" className="text-[#00A8FF] hover:underline mt-2 inline-block">Voltar à página principal</Link>
        </div>
      </div>
    </div>
  );
}
